<section class="d-flex flex-column gap-3 need-help-popup">
    <div>
      <p>If you would like to make changes to your order or have questions regarding an existing order, please contact
        our Customer Service team below:</p>
      <div class="d-flex flex-row gap-2 align-items-center">
        <div class="icon-container">
          <i class="pi pi-envelope"></i>
        </div>
        <a href="mailto:EXLRetrieval.CustomerService@exlservice.com" class="text-underline color-black">EXLRetrieval.CustomerService&#64;exlservice.com</a>
      </div>
    </div>
    <div>
      <p>If you require any technical assistance, please contact our help desk below:</p>
      <div class="d-flex flex-row gap-2 align-items-center">
        <div class="icon-container">
          <i class="pi pi-envelope"></i>
        </div>
        <a href="mailto:EXLRecords.Helpdesk@exlservice.com" class="text-underline color-black">EXLRecords.Helpdesk&#64;exlservice.com</a>
      </div>
    </div>
  </section>
